import { AvatarConfig } from "../avatar/common/player/type";
import { ResourceType } from "../base/loader/type";
import { SmartScenarioBuilders } from "../avatar/common/player/util";
import { defaultConfig } from "./default.config";
import type { CameraConfig } from '../base/camera/type';
import type { LightingConfig } from '../base/light/type';
import type { RendererConfig } from '../base/renderer/type';
import type { LoaderConfig } from '../base/loader/type';
import type { ScenarioConfigs } from '../avatar/common/animation/type';

// Kikiz 리소스 설정
export const kikizResources: ResourceType[] = [
  { name: "kikiz", type: "model_only", path: "/glb/avatars/kz_avatar_kikiz_expo.glb", format: "glb" },
  { name: "greeting_entrance01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@greeting_entrance01.glb", format: "glb" },
  { name: "greeting_entrance02", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@greeting_entrance02.glb", format: "glb" },
  { name: "greeting_start01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@greeting_start01.glb", format: "glb" },
  { name: "greeting_start02", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@greeting_start02.glb", format: "glb" },
  { name: "idle_standby01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@idle_standby01.glb", format: "glb" },
  { name: "input_listening01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@input_listening01.glb", format: "glb" },
  { name: "input_listening02", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@input_listening02.glb", format: "glb" },
  { name: "input_listening03", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@input_listening03.glb", format: "glb" },
  { name: "response_speaking01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking01.glb", format: "glb" },
  { name: "response_speaking02", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking02.glb", format: "glb" },
  { name: "response_speaking03", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking03.glb", format: "glb" },
  { name: "response_speaking04", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking04.glb", format: "glb" },
  { name: "response_speaking05", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking05.glb", format: "glb" },
  { name: "response_speaking06", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking06.glb", format: "glb" },
  { name: "response_speaking07", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_speaking07.glb", format: "glb" },
  // { name: "response_unavailable01", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_unavailable01.glb", format: "glb" },
  // { name: "response_unavailable02", type: "animation_only", path: "/glb/animations/kikiz/kz_kiosk@response_unavailable02.glb", format: "glb" },
];

/**
 * Kikiz 시나리오 설정 - 스마트 빌더 사용
 */
const KIKIZ_SCENARIOS: ScenarioConfigs<string> = {
  entrance: SmartScenarioBuilders.auto("greeting_entrance", kikizResources, {
    preferredMode: 'once',
    description: "입장 애니메이션 (01~02 중 랜덤 선택)",
    nextScenario: "start"
  }),

  start: SmartScenarioBuilders.auto("greeting_start", kikizResources, {
    preferredMode: 'once',
    description: "시작 애니메이션 (01~02 중 랜덤 선택)",
  }),

  toss: SmartScenarioBuilders.auto("idle_standby", kikizResources, {
    preferredMode: 'last_loop',
    description: "대기 상태"
  }),

  // processing: SmartScenarioBuilders.auto("idle_standby", kikizResources, {
  //   preferredMode: 'last_loop',
  //   description: "대기 상태"
  // }),

  // waiting: SmartScenarioBuilders.auto("input_listening", kikizResources, {
  //   preferredMode: 'last_loop',
  //   description: "사용자 입력을 듣는 상태"
  // }),

  listening: SmartScenarioBuilders.auto("input_listening", kikizResources, {
    preferredMode: 'last_loop',
    description: "사용자 입력을 듣는 상태"
  }),

  speaking: SmartScenarioBuilders.auto("response_speaking", kikizResources, {
    preferredMode: 'random',
    description: "말하기 상태"
  }),

  // error: SmartScenarioBuilders.auto("response_unavailable", kikizResources, {
  //   preferredMode: 'last_loop',
  //   description: "사용 불가 상태 애니메이션"
  // }),
};

// 카메라 설정
const kikizCameraConfig: CameraConfig = {
  ...defaultConfig.camera,
  cameras: [
    {
      name: "kikiz_main_camera",
      type: "PerspectiveCamera",
      active: true,
      fov: 40,
      position: { x: 0, y: 0.43, z: 2 },
      rotation: {
        x: 0.04,
        y: 0,
        z: 0
      },
      near: 0.1,
      far: 200
    }
  ]
};

// 조명 설정 - 최소한의 조명만 설정
const kikizLightConfig: LightingConfig = {
  ...defaultConfig.lighting,
  // lights: [],
  // // 환경맵 설정
  environment: undefined
};

// 렌더러 설정 - bloom 없음
const kikizRendererConfig: RendererConfig = {
  ...defaultConfig.renderer,
  bloom: undefined
};

// 로더 설정
const kikizLoaderConfig: LoaderConfig = {
  ...defaultConfig.loader
};

/**
 * Kikiz 아바타 설정
 */
export const kikizAvatarConfig: AvatarConfig = {
  type: 'kikiz' as const,
  modelKey: 'kikiz',
  resources: kikizResources,
  scenarioConfigs: KIKIZ_SCENARIOS,
  lipsync: {
    // indices: [22, 24, 31, 33, 34, 37, 40, 41, 43, 44, 45, 46, 47, 48],
    // processingType: 'filter',
    // config: {
    //   indices: [22, 24, 31, 33, 34, 37, 40, 41, 43, 44, 45, 46, 47, 48],
    // }
  },
};

// Kikiz 통합 설정 인터페이스
export interface KikizConfig {
  loader: LoaderConfig;
  camera: CameraConfig;
  lighting: LightingConfig;
  renderer: RendererConfig;
  avatar: AvatarConfig;
}

/**
 * Kikiz 설정 통합 객체
 */
export const kikizConfig: KikizConfig = {
  loader: kikizLoaderConfig,
  camera: kikizCameraConfig,
  lighting: kikizLightConfig,
  renderer: kikizRendererConfig,
  avatar: kikizAvatarConfig
};
